import Modal from "react-bootstrap/Modal";
import React from "react";
import { useShoppingCart } from "../context/ShoppingCartContext";
import CheckoutPaymentMethodButton from "./CheckoutPaymentMethodButton";
import {
  getPaymentStepNumber,
  useCheckoutConfig,
} from "./checkoutConfig";

interface Props {
  show: boolean;
  setShow: (val: boolean) => void;
  onPaymentMethodSelected?: () => void;
  onCancel?: () => void;
}

export default function CheckoutSelectPaymentMethodModal({
  show,
  setShow,
  onPaymentMethodSelected,
  onCancel,
}: Props) {
  const { paymentMethods } = useShoppingCart();
  const checkoutConfig = useCheckoutConfig();
  const paymentStep = getPaymentStepNumber(checkoutConfig);

  const handlePaymentSelected = () => {
    if (onPaymentMethodSelected) {
      onPaymentMethodSelected();
    } else {
      setShow(false);
    }
  };

  const handleHide = () => {
    if (onCancel) {
      onCancel();
    } else {
      setShow(false);
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleHide}
      contentClassName="modal-600 selectPaymentMethodModal shop-controlled-border-radius"
    >
      <Modal.Header
        closeButton
        style={{
          borderTopLeftRadius: "var(--shop-border-radius)",
          borderTopRightRadius: "var(--shop-border-radius)",
        }}
      >
        <Modal.Title>
          <span className="badge badge-square badge-primary me-3 shop-controlled-color">
            {paymentStep}
          </span>
          <span className="fw-bold">VALI MAKSEVIIS</span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="paymentMethodNotSelected padding-bottom-15">
          {paymentMethods
            ? paymentMethods.map((pm) => (
                <CheckoutPaymentMethodButton
                  key={pm.uuid}
                  paymentMethod={pm}
                  setShowParentModal={setShow}
                  onPaymentSelected={handlePaymentSelected}
                />
              ))
            : ""}
        </div>
      </Modal.Body>
    </Modal>
  );
}
